import React from "react";
import { Fit, RowStack } from "@skbkontur/react-stack-layout";

import { declint } from "../../../../../Engine/utils";
import { isErrorCountExceeds } from "../Utils/Utils";
import { Icon } from "../../../../Icons/Icon";
import { ErrorLog } from "../../../../../Engine/Core/ErrorManager/Utils/Models";
import { useCandyTheme } from "../../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";

interface ErrorLogCountersProps {
    errorLog: ErrorLog;
    useExtendedErrorLog?: boolean;
}

export function ErrorLogCounters({ useExtendedErrorLog, errorLog }: ErrorLogCountersProps): JSX.Element {
    const errorCount = errorLog.errorsTotalCount;
    const warningCount = errorLog.warningsTotalCount;
    const theme = useCandyTheme();

    const showCountWarning = (): boolean =>
        warningCount > 0 && (useExtendedErrorLog ? !isErrorCountExceeds(errorCount) : true);

    const errorCountText = `${declint(errorCount, ["%s ошибка", "%s ошибки", "%s ошибок"])}`;
    const warningCountText = `${declint(warningCount, [
        "%s предупреждение",
        "%s предупреждения",
        "%s предупреждений",
    ])}`;

    return (
        <RowStack gap={4}>
            {errorCount > 0 && (
                <Fit data-tid="protocol-errors-count">
                    <Icon name="XCircleIcon" weight="solid" color={theme.semanticColors.danger.iconColor} />{" "}
                    {errorCountText}
                </Fit>
            )}
            {showCountWarning() && (
                <Fit data-tid="protocol-warnings-count">
                    <Icon name="WarningCircleIcon" weight="solid" color={theme.semanticColors.warning.iconColor} />{" "}
                    {warningCountText}
                </Fit>
            )}
        </RowStack>
    );
}
